<sc-sized-container [minWidth]="600">
  <div class="mat-body confirm-dialog">
    <sc-dialog-title>
      <sc-dictionary-label [dictionaryKey]="data.titleKey"></sc-dictionary-label>
    </sc-dialog-title>

    <mat-dialog-content>
      <div [innerHTML]="'#undefined' | translate: getMessageArgs() | trustHtml"></div>
    </mat-dialog-content>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary (click)="confirm()"></sc-confirm-button>
    </sc-flex>
  </div>
</sc-sized-container>
